import {
  BillingIntervalEnum,
  TBillingProductForCheckoutResponse,
} from '@commenda/types/src/billing/types';
import { fetcher } from '@commenda/utils';
import { Currency } from '@prisma/client';

export type TGetProductsForCheckoutQuery = {
  items: {
    productId: string;
    billingInterval: BillingIntervalEnum;
  }[];
  currency?: Currency;
};

export async function getProductsForCheckout(
  query: TGetProductsForCheckoutQuery
): Promise<TBillingProductForCheckoutResponse | null> {
  try {
    const res = await fetcher(`billing-new/checkout/products`, {
      method: 'POST',
      body: query,
    });

    return res as TBillingProductForCheckoutResponse;
  } catch (err) {
    console.error(err);
    return null;
  }
}
